import { Navigate } from 'react-router-dom';

const Home = () => <Navigate replace to="/dashboard" />;

export default Home;
